import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import GoogleTrustPill from "@/components/GoogleTrustPill";
import reviewsData from "@/data/reviews.json";

/**
 * Social-proof anchor for high-intent pages (Pricing, Switch & Save).
 *
 * Pairs the live Google rating pill (external) with an internal CTA to our
 * own /reviews page. Two links, two intents, visually differentiated:
 *  - Live Google rating → authority, third-party verification.
 *  - "See all N reviews" → keeps warm prospects on-site, boosts internal SEO.
 *
 * The review total is pulled from /data/reviews.json so the number always
 * matches the dedicated /reviews page (no manual sync required).
 *
 * @param {string} reassurance  Optional reassurance line shown in the trust pill.
 * @param {string} testId       data-testid prefix.
 */
export default function SocialProofStrip({ reassurance = "", testId = "social-proof-strip" }) {
  const total = reviewsData?.totals?.total || 0;

  return (
    <div
      className="flex flex-col items-center gap-3"
      data-testid={testId}
    >
      <GoogleTrustPill
        variant="card"
        reassurance={reassurance}
        testId={`${testId}-google`}
      />
      {total > 0 && (
        <Link
          to="/reviews"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-aqua-dark hover:text-brand-black transition-colors group"
          data-testid={`${testId}-all-reviews`}
        >
          {`See all ${total} verified reviews on our site`}
          <ArrowRight
            size={14}
            className="transition-transform group-hover:translate-x-0.5"
          />
        </Link>
      )}
    </div>
  );
}
